import React from 'react';

import { TMenuItemProps } from '@interlayer/js/app/components/main/Skeleton/types';

import style from './MenuItem.scss';

export const MenuItem: React.FC<TMenuItemProps> = ({ count = 0 }) => {
    return (
        <>
            {Array.from({ length: count }, () => (
                <div className={style.wrapper}>
                    <div className={style.item} />
                </div>
            ))}
        </>
    );
};
